<template>
		<div class="text-input" v-cloak>
				<input
						:type="type"
						:name="name"
						:id="name"
						class="form-control text-input"
						:class="className"
						required
						:autocomplete="autocomplete"
						:autofocus="autofocus"
						:value="value"
						v-on:input="$emit('input', $event.target.value)"
				>
				<label :for="name" class="text-input-label">
						{{ label }}
				</label>

				<span class="invalid-feedback" role="alert" v-if="hasError()">
						{{ error }}
				</span>
		</div>
</template>

<script>
export default {
	computed: {
		/**
		 * Returns the "is-invalid" classname if an error exists.
		 *
		 * @returns {string|null}
		 */
		className () {
			if (this.hasError()) {
				return 'is-invalid';
			}

			return null;
		}
	},

	methods: {
		/**
		 * Returns true if an error exists.
		 *
		 * @returns {bool}
		 */
		hasError () {
			return this.error !== '';
		}
	},

	props: {
		type: {
			type: String,
			default: 'text'
		},
		label: String,
		name: String,
		error: {
			type: String,
			default: ''
		},
		value: {
			type: String,
			default: ''
		},
		autocomplete: {
			type: String,
			default: null
		},
		autofocus: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style lang="scss">
// Extending Bootstrap Inputs

@import '../../variables';

.text-input {

		>input {
				border: none;
				border-bottom: 1px solid $light-gray;
				background-color: transparent;
				border-radius: 0;
				margin-top: 20px;
				margin-bottom: 1px;
				padding: 0.375rem;

				&:hover {
						border-bottom: 1px solid $gray;
				}

				&:focus,
				&:valid {
						background-color: transparent;
						outline: none;
						box-shadow: none;
						border-bottom: 2px solid $blue;
						margin-bottom: 0;
				}

				~ .text-input-label {
						position: relative;
						top: -30px;
						left: 6px;
						pointer-events: none;
						transition: 300ms ease all;
						transform: translate(0, 0) scale(1);
						margin-bottom: 0;
						height: 0;

						~.invalid-feedback {
								margin-top: -1.5em;
						}
				}

				&:focus ~ .text-input-label,
				&:valid ~ .text-input-label {
						color: $blue;
						transform: translate(-6px, -25px) scale(0.9);
				}

				&.is-invalid {
						&:hover,
						&:focus,
						&:valid {
								border-color: $red;
						}

						&:focus {
								box-shadow: none;
						}

						~ .text-input-label {
								color: $red;
						}
				}

				&[type=password] {
						letter-spacing: 0.3em;
				}
		}
}
</style>
